import React, {useState} from 'react';
import TextInput from "../../../../Common/components/text-input";
import SelectInput from "../../../../Common/components/select-input";
import {useGetUserGroupsQuery} from "../../../../../../redux/apiSlice";

function Tab1({tab, onValidate}) {
    const [submitAttempted, setSubmitAttempted] = useState(false)
    const {isFetching, data: userGroups, error} = useGetUserGroupsQuery()

    const handleSubmit = _ => {
        onValidate();
        setSubmitAttempted(true)
    }

    return (
        <div className="form mt-0 mt-lg-10">
            <div
                className="pb-5"
                data-wizard-type="step-content"
                data-wizard-state={tab === 1 ? "current" : ""}
            >
                <div className="mb-10 h3 font-weight-bold text-dark">Exchange Rate Details</div>
                <div className="row">
                    <TextInput
                        label="From Currency*"
                        name="fromCurrency"
                        type="text"
                        shouldShowError={submitAttempted}
                    />
                    <TextInput
                        label="To Currency*"
                        name="toCurrency"
                        type="text"
                        shouldShowError={submitAttempted}
                    />
                </div>
                <div className="row">
                    <TextInput
                        label="Rate*"
                        name="rate"
                        type="number"
                        shouldShowError={submitAttempted}
                    />
                    <SelectInput
                        label="User Group"
                        name="userGroup"
                        shouldShowError={submitAttempted}
                        options={userGroups?.map((userGroup) => userGroup?.name)}
                    />
                </div>

                {/* <!--begin: Wizard Actions--> */}
                <div className="text-right border-top mt-5 pt-10">
                    <button
                        onClick={handleSubmit}
                        type="button"
                        className="btn btn-primary font-weight-bolder text-uppercase px-9 py-4"
                    >
                        Next
                    </button>
                </div>
                {/* <!--end: Wizard Actions--> */}
            </div>
        </div>
    );
}

export default Tab1;